module.exports = __webpack_public_path__ + "static/media/noclass10.8fed14c7.png";